import { render, staticRenderFns } from "./SearchEvents.vue?vue&type=template&id=57a178b5&scoped=true"
import script from "./SearchEvents.vue?vue&type=script&lang=js"
export * from "./SearchEvents.vue?vue&type=script&lang=js"
import style0 from "./SearchEvents.vue?vue&type=style&index=0&id=57a178b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a178b5",
  null
  
)

export default component.exports